function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M219.141 192.227C224.807 203.306 230.794 214.091 236.839 224.969C240.04 230.727 250.361 254.545 253.027 255.455C255.897 256.434 273.48 246.094 278.527 244.069C287.495 240.469 296.016 237.061 305.383 234.841C315.872 232.356 326.444 230.523 337.325 231.447C342.09 231.852 349.977 233.005 345.241 226.31C341.789 221.429 338.444 216.934 333.755 213.407C330.342 210.84 325.34 206.131 321.344 204.416C317.151 202.616 310.968 203.015 306.462 203.121C301.591 203.236 278.374 210.481 277.097 202.93C274.729 205.085 273.35 204.252 270.637 205.304C267.578 206.49 265.672 208.792 262.635 210.183C260.664 211.085 257.032 214.653 254.842 214.674C251.93 214.703 251.146 212.292 249.055 210.512C244.371 206.523 238.133 203.898 233.05 200.433C228.574 197.381 224.313 194.199 219.141 192.227ZM270.146 104.648C270.544 109.706 269.18 114.406 269.212 119.611C269.226 121.882 269.33 124.152 268.64 126.34C268.021 128.301 268.454 131.825 268.125 133.879C273.919 132.115 284.682 129.499 290.598 131.878C296.253 134.151 296.964 144.666 297.163 149.78C297.299 153.265 295.752 158.635 296.924 161.972C297.471 163.528 297.476 164.031 297.442 164.171L297.437 164.186C297.549 164.128 298.003 164.129 299.604 165.285C301.192 166.429 303.087 167.061 304.656 168.324C307.509 170.626 307.998 173.235 309.406 176.571C310.774 179.811 314.417 182.691 318.485 182.573C315.216 176.648 310.676 171.114 313.281 164.154C315.246 158.902 311.802 152.737 309.092 147.747C308.194 146.095 298.248 133.434 302.655 132.541C305.517 131.961 312.086 145.401 313.343 147.747C316.848 145.377 318.422 142.457 315.725 138.887C313.652 136.146 311.108 133.802 309.092 130.964C305.817 126.358 302.625 120.859 298.736 116.768C291.906 109.583 279.982 104.692 270.146 104.648ZM297.437 164.186C297.399 164.212 297.416 164.238 297.433 164.199L297.437 164.186ZM178.35 96.7985C173.985 100.98 168.464 104.448 164.246 108.837C160.554 112.678 155.582 119.14 153.828 124.272C162.828 126.007 177.782 131.32 181.365 140.765C195.363 127.916 200.777 151.407 203.555 161.23C211.746 157.685 210.113 145.884 210.004 138.994C209.92 133.528 206.591 127.059 214.527 126.611C220.458 126.278 226.218 128.693 231.566 130.955C238.241 133.777 245.242 137.999 250.633 142.848L256.25 138.475C247.036 133.302 242.233 123.411 236.839 114.354C235.119 111.467 232.821 108.256 231.566 105.135C230.698 102.977 230.087 98.6206 229.136 96.7016C227.639 93.6849 213.02 92.8544 209.148 92.0769C198.924 90.0247 186.704 88.7948 178.35 96.7985Z",
  fill: "#FCB0B3"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M180.68 163.841C176.903 163.648 173.143 164.491 169.367 164.123C172.646 161.267 175.924 158.412 179.203 155.557C180.652 158.101 180.757 160.994 180.68 163.841ZM270.274 105.135C280.049 105.178 291.972 110.088 298.763 117.258C302.36 121.058 305.333 126.161 308.376 130.431C310.416 133.295 312.409 136.06 314.886 138.577C318.498 142.246 317.464 143.084 313.394 145.847C312.106 143.433 305.277 130.529 302.414 131.109C298.064 131.992 306.465 145.623 307.382 147.321C310.1 152.346 314.487 159.364 312.516 164.663C309.915 171.658 313.687 175.645 316.962 181.605C313.522 181.705 313.183 180.363 311.998 177.43C310.476 173.659 308.814 170.509 305.595 167.902C303.102 165.884 299.024 165.034 297.852 162.597C296.404 159.584 297.313 153.635 297.195 150.284C297.017 145.191 297.004 133.152 291.392 130.89C285.513 128.519 274.941 130.753 269.194 132.509C269.911 128.022 272.175 125.09 272.144 120.103C272.11 114.883 270.673 110.225 270.274 105.135ZM345.366 188.421C340.253 186.802 335.406 185.096 330.145 183.993C324.64 182.838 324.272 181.517 321.169 176.796C318.817 173.218 315.962 170.428 316.629 166.046C317.056 163.234 318.595 161.865 318.132 158.703C317.846 156.744 316.931 154.605 316.27 152.741C315.46 150.455 313.781 147.863 317.685 147.75C319.841 147.687 319.947 148.824 321.406 150.734C324.099 154.262 327.197 157.465 330.063 160.849C335.04 166.723 340.317 172.974 345.873 178.411C351.988 184.394 357.267 191.61 361.22 199.269C361.95 200.684 366.389 209.015 364.495 210.648C362.756 212.149 353.083 208.65 351.319 208.24C343.706 206.473 335.065 205.842 327.872 202.633C324.208 200.997 316.121 199.045 313.226 196.515C310.535 194.163 310.657 188.465 312.218 185.149C316.588 187.867 348.183 198.125 345.366 188.421ZM250.247 141.665C245.145 137.057 239.114 133.36 232.814 130.621C227.179 128.171 220.18 125.44 213.911 125.865C206.101 126.394 209.365 132.686 209.393 138.043C209.429 145.152 212.545 155.393 204.056 159.081C201.285 149.238 195.445 125.961 181.453 138.86C177.878 129.395 165.125 126.192 156.144 124.454C157.772 119.672 162.716 115.343 166.143 111.754C170.43 107.264 173.815 102.002 178.109 97.5971C186.594 88.8984 201.964 91.6919 212.705 93.8603C216.291 94.5834 226.685 95.4922 228.422 98.1252C229.511 99.7767 228.903 103.811 229.71 105.83C230.823 108.613 232.723 111.191 234.248 113.761C239.812 123.137 245.472 132.574 254.994 137.942L250.247 141.665ZM219.11 192.177C224.148 194.11 227.853 197.342 232.322 200.064C237.739 203.364 244.092 206.455 248.954 210.532C250.733 212.023 251.732 214.598 254.188 214.765C256.324 214.91 259.579 212.43 261.472 211.562C264.649 210.103 267.683 207.894 270.875 206.594C273.499 205.526 274.66 205.744 276.93 203.667C278.204 211.246 301.367 204.162 306.226 204.046C310.721 203.94 316.889 204.473 321.073 206.279C325.059 208 328.176 211.789 331.588 214.371C336.265 217.911 340.729 221.491 344.173 226.391C348.898 233.11 341.77 231.209 337.016 230.803C326.165 229.875 315.61 232.46 305.15 234.954C295.8 237.183 286.566 239.857 277.615 243.472C272.582 245.505 267.284 247.374 262.55 250.016C260.054 251.41 256.006 254.821 253.142 253.838C250.515 252.936 247.898 245.408 246.306 242.4C243.213 236.563 239.96 230.824 236.767 225.044C230.737 214.126 224.763 203.299 219.11 192.177ZM281.1 336.683C277.995 334.9 272.935 335.38 269.501 334.633C265.622 333.789 261.722 332.413 258.023 330.979C254.277 329.527 250.737 328.042 247.315 326.225C245.749 325.395 243.663 324.577 242.216 323.424C241.051 322.495 240.626 320.769 239.551 319.926C236.747 317.727 235.923 319.107 235.546 314.865C235.139 310.256 237.724 307.647 240.942 304.198C243.824 301.112 247.567 298.444 251.187 296.273C252.789 295.313 254.5 294.233 256.134 293.316C258.607 291.928 261.92 289.62 263.218 292.6C260.516 293.289 259.92 296.74 262.359 297.981C263.699 298.662 265.726 297.661 267.236 298.385C269.568 299.503 271.811 302.622 273.806 304.302C280.357 309.817 286.622 311.885 295.196 312.328C313.112 313.251 331.873 311.208 349.444 308.553C353.966 307.869 358.481 308.61 363.045 308.446C367.487 308.288 372.117 307.316 376.483 306.566C384.892 305.122 393.755 303.933 402.033 301.808C412.045 299.237 422.091 295.912 431.49 291.606C440.507 287.475 450.698 280.648 460.825 280.122C456.503 284.353 450.028 285.984 444.83 288.77C440.581 291.047 433.937 292.509 431.252 296.261C429.505 298.703 428.629 303.188 427.309 306.051C425.849 309.22 424.502 312.439 423.15 315.655C421.793 318.891 420.379 322.128 419.277 325.461C418.595 327.529 418.301 331.815 416.689 333.23C414.117 335.486 405.51 336.487 402.045 337.237C395.574 338.639 388.194 338.453 381.594 338.55C378.866 338.59 376.118 338.962 373.512 339.013C369.852 339.083 370.201 338.449 370.253 335.272C370.283 333.364 370.245 329.894 367.693 331.465C365.954 332.536 367.151 337.279 367.473 338.964C352.905 340.415 337.706 341.145 323.207 340.659C308.949 340.182 295.184 338.343 281.1 336.683ZM215.311 303.243C212.741 284.785 209.608 266.018 206.102 247.799C202.559 229.388 198.299 211.145 193.507 192.803C196.672 192.045 199.838 191.29 203.003 190.533C203.12 194.398 204.427 197.755 204.984 201.602C205.753 206.912 207.223 212.068 208.104 217.36C209.775 227.42 212.873 237.263 215.603 247.073C218.384 257.074 219.314 267.378 221.869 277.429C223.976 285.71 225.052 294.831 226.228 303.345C229.082 323.997 233.148 344.69 236.242 365.353C239.144 384.726 239.435 404.492 239.268 424.046C239.165 435.984 237.344 447.888 237.439 459.842C237.463 462.797 237.214 465.742 237.06 468.692C236.952 470.774 238.07 476.544 237.122 478.288C236.522 479.392 233.943 480.409 233.03 481.942C231.586 484.367 231.282 487.266 228.962 489.102C227.082 481.519 227.971 471.511 228.382 463.773C228.779 456.317 228.007 448.611 227.855 441.04C227.558 426.189 226.772 411.555 226.01 396.697C225.176 380.402 222.802 363.711 220.483 347.539C218.375 332.834 216.968 317.868 215.311 303.243ZM284.112 71.7623C285.131 71.6671 286.15 71.5729 287.17 71.4777C287.018 73.6256 287.471 77.1039 285.957 78.2245C284.81 79.0735 282.487 78.7946 281.096 79.0661C276.537 79.9571 271.254 80.7026 266.729 79.0791C264.971 78.4484 266.1 77.4603 263.679 77.8709C260.762 78.3663 261.827 78.8282 260.985 80.6476C260.337 82.0518 260.002 84.4413 259.266 86.1273C258.28 88.3834 256.283 92.4206 257.137 95.0257C257.967 97.5579 261.064 98.323 262.38 101.191C263.359 103.323 263.127 106.423 263.636 108.771C264.315 111.903 265.172 115.023 265.551 118.213C266.028 122.232 265.865 126.948 260.885 127.571C256.264 128.15 252.96 126.665 249.861 123.299C243.942 116.875 237.185 107.805 233.708 99.7226C233.302 98.7783 232.302 97.2024 232.441 96.1919C232.716 94.1925 232.837 96.2162 233.471 94.8279C234.075 93.5001 235.025 92.2956 235.583 90.8223C237.591 85.5292 239.014 79.9814 239.819 74.3785C240.184 71.8407 240.306 69.3336 240.243 66.7705C240.223 65.8954 239.697 63.2679 240.011 62.6689C240.33 62.0615 241.995 61.7816 242.514 61.1789C243.477 60.062 245.13 56.9084 246.196 56.0724C247.507 55.0451 250.441 55.8587 250.974 53.8153C251.826 50.5451 231.659 45.2184 241.081 40.8545C248.115 37.5964 258.904 54.0663 261.363 41.1065C261.79 38.8616 260.978 35.8143 261.962 33.7569C263.051 31.4831 266.013 30.6331 268.083 29.5266C270.723 28.1158 273.391 26.6659 275.957 25.1208C277.717 24.0618 280.253 21.2496 282.127 20.9921C281.389 24.8091 282.803 28.5926 282.827 32.4022C278.768 31.304 275.976 31.2807 271.97 33.2335C270.062 34.1628 262.875 39.4373 266.517 41.9742C269.467 40.2303 272.623 38.7179 275.911 37.6925C277.209 37.2875 278.828 36.7371 280.208 36.7091C283.41 36.6447 282.959 36.9796 284.161 39.3943C285.321 41.7204 285.071 47.787 287.616 49.2724C290.247 50.8082 288.218 48.6585 290.465 49.1548C291.746 49.4385 293.143 50.3911 294.316 50.9295C292.709 52.6742 289.464 54.2669 288.398 56.2048C286.843 59.0301 287.383 64.8737 287.139 67.9648C285.103 67.2361 282.96 67.2063 280.896 66.6651C278.957 66.1557 276.267 63.9509 276.064 67.1923C275.838 70.8041 281.548 71.7623 284.112 71.7623ZM257.616 166.855C257.457 163.734 257.283 160.614 256.936 157.506C256.702 155.419 254.72 149.366 255.84 147.532C257.058 145.538 261.141 145.411 263.106 144.933C266.872 144.015 270.484 143.263 274.312 142.656C277.833 142.099 281.15 141.982 284.698 141.82C288.561 141.646 289.519 140.62 290.373 144.878C291.044 148.225 291.945 151.712 292.07 155.14C292.188 158.357 291.216 161.15 294.404 163.318C287.403 163.318 278.285 157.085 271.896 162.659C262.757 170.63 278.661 172.926 282.855 174.685C279.368 176.38 274.193 177.71 272.552 181.581C270.71 185.918 273.383 187.763 277.472 188.11C277.087 189.782 275.615 190.868 275.177 192.879C274.534 195.826 276.618 194.85 273.959 197.131C270.459 200.132 263.253 202.139 258.961 204.051C257.955 204.501 256.938 204.922 255.909 205.317C254.301 206.748 253.114 206.476 252.347 204.499C250.145 203.105 248.185 199.995 246.231 198.186C241.885 194.161 237.088 190.628 231.924 187.722C234.065 186.835 236.625 188.839 238.68 187.864C240.34 187.075 239.715 185.641 240.709 184.567C240.311 183.167 240.731 182.654 241.972 183.031C242.592 183.097 243.169 182.991 243.702 182.716C244.741 181.428 245.208 181.007 245.277 179.018C245.35 176.909 244.128 176.164 243.66 174.476C242.135 173.437 242.17 172.416 243.763 171.416C244.418 170.345 244.776 169.183 244.835 167.93C245.138 163.277 240.891 161.402 237.652 158.94C243.451 158.303 243.23 151.501 239.217 148.528C235.058 145.445 226.252 146.707 221.223 147.403C220.176 147.546 217.351 148.895 216.293 148.035C215.645 147.508 216.103 143.051 216.073 142.264C216.005 140.478 215.571 138.349 215.856 136.573C216.451 132.853 215.189 134.726 217.867 134.623C224.24 134.375 232.356 139.939 237.963 142.562C244.239 145.498 248.272 145.95 248.338 153.229C248.4 160.123 250.333 166.991 251.177 173.774C251.546 176.736 251.809 192.127 257.231 186.447C259.333 184.244 257.986 180.857 257.83 178.14C257.618 174.401 257.744 170.604 257.616 166.855ZM608.219 397.597C605.117 398.147 600.063 396.366 596.679 396.18C590.76 395.854 584.665 395.291 578.867 394.059C574.331 393.095 569.161 392.247 566.715 387.856C564.528 383.932 563.755 379.017 562.577 374.735C561.952 372.461 560.338 369.164 560.338 366.811C560.338 363.753 560.751 364.356 563.94 362.682C567.977 360.564 571.905 357.613 576.259 356.411C577.576 356.153 578.894 355.901 580.213 355.654C581.919 354.664 582.882 355.151 583.105 357.113C584.771 358.869 585.747 362.105 587.144 364.159C590.33 368.841 594.113 372.032 599.055 374.732C607.949 379.589 616.235 383.338 625.761 386.514C631.01 388.265 635.851 390.721 640.982 392.65C645.092 394.196 650.765 394.666 653.923 398.107C657.486 401.99 652.01 403.401 648.966 406.026C646.472 408.177 646.423 408.67 643.012 407.626C640.47 406.848 638.217 405.361 635.776 404.352C627.416 400.899 617.297 398.601 608.219 397.597ZM417.149 459.177C420.264 458.503 423.381 457.829 426.497 457.156C423.432 462.877 416.987 471.247 421.613 477.868C423.342 480.341 426.218 481.047 428.786 482.302C431.895 483.821 434.766 485.766 437.705 487.576C449.825 495.039 462.142 502.606 474.913 509.01C470.915 510.3 464.768 511.193 460.651 510.069C455.856 508.759 451.416 505.753 446.494 504.438C437.663 502.081 428.367 500.074 419.395 498.865C412.062 497.877 393.705 500.11 394.596 489.08C395.443 478.609 401.697 468.619 403.559 458.267C408.126 459.281 412.483 459.104 417.149 459.177ZM231.425 291.576C227.873 274.145 225.751 256.418 221.562 239.112C219.472 230.479 218 221.727 215.958 213.092C215.008 209.074 214.29 205.017 213.365 201.007C212.428 196.948 210.412 193.201 209.951 189.004C213.345 189.844 214.13 197.617 215.158 200.541C217.046 205.906 219.104 211.061 221.529 216.197C225.384 224.361 229.474 232.238 233.822 240.153C238.407 248.502 243.251 256.53 248.979 264.154C250.861 266.659 253.414 268.623 254.628 271.37C256.536 275.693 257.337 280.845 259.159 285.343C257.876 285.995 254.562 286.157 252.988 286.468C250.061 287.045 248.01 287.558 245.199 288.951C240.246 291.403 236.085 294.309 232.776 298.72C231.944 296.456 231.728 293.973 231.425 291.576ZM369.469 424.57C369.528 407.783 369.766 390.852 369.491 374.189C369.415 369.562 369.038 364.57 368.367 359.979C367.946 357.093 365.467 350.958 367.096 349.575C368.489 348.391 375.84 349.171 377.645 349.129C381.144 349.047 384.632 348.892 388.138 348.628C388.138 354.85 385.707 361.915 384.578 368.069C383.525 373.81 382.66 379.583 381.791 385.35C379.91 397.839 379.375 410.5 377.333 423.022C375.483 434.376 373.042 445.683 371.696 457.035C370.958 463.267 369.463 469.146 368.302 475.374C367.696 478.622 365.484 491.998 362.699 493.313C362.11 488.515 364.516 482.721 364.947 477.869C365.391 472.859 365.735 467.816 366.548 462.781C367.501 456.869 367.983 450.811 368.349 444.826C368.572 441.164 368.64 437.513 368.957 433.854C369.185 431.198 370.191 427.174 369.469 424.57ZM281.984 200.087C281.868 198.26 286.599 198.333 287.481 196.232C289.268 191.965 285.194 192.733 282.689 192.292C283.582 189.919 300.307 190.783 296.41 184.378C293.707 179.934 283.457 186.736 280.717 182.513C278.917 179.739 283.817 179.357 285.76 179.079C288.685 178.66 295.574 180.014 295.347 176.219C295.062 171.452 281.668 168.161 277.911 166.76C278.328 163.496 294.447 168.136 296.78 169.46C302.06 172.455 306.106 177.83 306.88 183.803C307.783 190.753 304.258 196.226 297.317 197.932C294.422 198.643 292.283 198.722 289.605 199.792C287.843 200.494 282.14 202.247 280.932 200.474C281.283 200.345 281.633 200.216 281.984 200.087ZM187.354 156.859C187.087 153.891 184.589 148.304 187.467 146.354C191.496 143.625 193.165 148.122 194.078 150.823C195.194 154.121 199.886 162.195 195.783 164.25C194.829 164.728 190.306 164.172 189.508 163.857C187.285 164.436 186.568 163.604 187.354 161.358V156.859ZM285.663 396.538C285.916 388.426 282.284 378.674 280.226 370.729C277.893 361.727 276.663 352.546 274.192 343.643C276.942 343.974 279.717 344.245 282.434 344.796C286.14 345.549 286.206 345.431 285.94 349.067C285.543 354.527 286.064 359.881 286.346 365.339C286.91 376.268 285.534 387.376 286.449 398.236C285.633 398.443 285.372 397.877 285.663 396.538ZM183.036 183.945C174.131 185.308 165.596 188.131 157.492 191.925C153.025 194.016 148.105 196.263 143.113 197.098C137.567 198.026 131.686 197.591 126.022 197.949C124.025 198.075 118.777 199.045 116.83 197.87C114.901 196.707 115.053 194.735 114.962 192.385C114.728 186.34 117.465 180.421 119.925 174.997C122.035 170.344 123.631 166.791 126.907 162.788C131.113 157.647 134.775 152.099 138.714 146.734C141.684 142.689 144.685 138.702 147.712 134.662C149.878 131.77 149.775 130.774 153.039 131.098C156.253 131.417 159.489 133.317 162.516 134.323C167.009 135.818 172.45 136.638 176.547 139.028C179.196 140.573 179.315 140.857 179.284 143.554C179.255 146.066 178.445 149.129 176.943 151.094C173.822 155.173 168.648 157.332 164.208 159.367C161.639 160.543 159.42 162.213 157.133 163.836C154.67 165.586 149.699 166.617 147.814 168.612C142.325 174.422 152.317 173.274 155.108 173.098C161.132 172.72 167.124 172.777 173.193 172.773C179.817 172.768 186.388 172.46 192.919 172.676C196.744 172.802 201.133 170.862 203.611 167.628C204.811 166.061 205.278 164.581 206.847 162.955C208.904 160.827 210.692 158.585 213.193 156.938C217.286 154.244 224.724 152.719 229.596 153.725C227.852 153.968 219.646 156.762 223.258 160.273C223.698 160.7 228.976 160.98 230.123 161.507C232.194 162.458 234.803 163.84 236.018 165.848C232.482 165.255 219.369 164.569 226.059 171.354C227.7 173.019 232.415 174.681 228.403 176.452C227.482 176.858 225.638 176.283 224.451 176.649C222.688 177.195 221.247 178.656 219.595 179.434C214.909 181.644 208.451 183.007 203.561 182.523C196.799 181.852 189.753 183.059 183.036 183.945ZM362.349 388.362C362.119 398.107 362.47 407.911 362.262 417.701C362.04 428.157 360.699 438.403 360.06 448.753C359.485 458.03 358.233 467.13 357.215 476.362C356.63 481.679 355.955 486.764 355.056 492.042C354.213 496.98 354.069 501.332 359.973 502.66C371.26 505.199 373.014 488.961 375.195 482.119C378.452 471.908 380.54 461.188 382.154 450.603C385.158 430.889 389.152 411.449 390.71 391.568C391.67 379.325 393.062 367.208 393.851 354.977C394.006 352.58 393.395 348.887 395.5 347.82C396.766 347.179 400.252 347.173 401.85 346.708C406.303 345.413 410.41 343.506 414.754 341.527C411.671 357.648 410.652 373.689 408.339 389.951C407.113 398.579 404.764 407.521 402.73 416.014C400.621 424.815 400.153 434.29 397.72 442.9C396.649 446.694 395.741 448.24 397.296 452.135C399.204 456.916 397.939 458.06 395.546 462.755C391.146 471.393 387.787 481.587 388.533 491.325C389.141 499.278 395.15 503.441 402.594 505.587C411.906 508.271 421.656 507.954 431.024 511.001C439.185 513.655 447.478 515.617 455.403 519.121C458.599 520.534 461.635 522.21 465.184 522.47C470.051 522.823 473.333 519.999 477.93 519.41C480.803 519.044 485.009 520.414 486.664 517.402C487.977 515.015 486.492 509.805 484.844 507.883C480.217 502.481 470.951 497.775 464.712 494.588C457.52 490.915 450.561 486.317 443.898 481.576C439.859 478.701 435.74 475.943 431.704 473.064C429.035 471.158 428.02 471.145 428.293 468.118C428.51 465.703 429.598 463.361 429.789 460.889C429.934 458.994 429.271 456.413 430.166 455.176C430.824 454.265 433.296 453.622 434.267 452.932C437.821 450.412 438.628 447.296 440.242 443.464C443.907 434.761 448.119 426.302 451.658 417.528C459.258 398.691 463.895 378.884 470.195 359.663C476.632 340.025 482.387 319.41 485.932 299.036C490.676 300.479 495.153 306.867 498.93 310.027C504.034 314.298 509.263 318.429 514.268 322.817C522.471 330.011 530.777 337.007 537.557 345.621C540.823 349.77 543.497 354.236 546.454 358.595C548.162 361.113 549.754 363.964 551.604 366.36C551.901 366.744 551.91 367.534 552.23 367.861C552.934 368.581 554.279 367.622 554.731 368.096C557.518 371.011 557.482 379.287 558.351 383.133C559.548 388.434 560.892 394.528 565.03 398.181C571.423 403.823 583.213 404.697 591.303 404.99C601.687 405.366 611.759 408.26 621.61 411.368C626.205 412.817 630.68 414.512 635.292 415.919C637.944 416.73 640.97 418.345 643.803 418.034C647.219 417.66 649.917 414.785 652.419 412.649C656.423 409.231 660.129 405.862 660 400.254C659.856 394.318 656.64 389.838 651.575 386.889C641.781 381.189 630.828 377.535 620.272 373.596C616.227 372.085 612.764 370.414 608.896 368.381C603.431 365.507 597.14 363.161 592.291 359.368C590.861 358.248 585.607 354.818 585.159 353.049C585.1 352.819 586.413 350.118 586.419 349.689C586.432 348.587 585.78 347.394 585.378 346.451C582.853 340.513 578.616 334.795 575.377 329.196C569.445 318.94 563.491 308.63 556.614 298.984C542.9 279.754 527.496 260.924 510.869 244.137C502.763 235.953 495.759 226.67 487.54 218.6C484.283 215.403 480.845 212.8 476.833 210.725C472.36 208.412 467.339 207.958 462.212 207.252C449.788 205.542 439.412 209.217 427.747 212.416C416.72 215.439 405.681 217.989 394.592 221.138C382.414 224.595 370.361 227.912 358.222 231.681C351.735 233.694 345.063 234.931 338.546 236.863C335.408 237.792 323.544 243.618 320.928 241.704C329.17 237.837 337.613 234.312 346.431 231.978C349.028 231.291 350.686 232.051 350.59 229.069C350.537 227.443 348.709 225.248 348.051 223.909C346.476 220.704 344.692 217.571 343.15 214.357C348.74 215.944 363.766 221.438 367.978 215.759C372.387 209.814 368.706 198.16 365.944 192.339C358.731 177.146 346.465 164.467 334.512 153.014C331.927 150.538 326.354 147.304 324.976 144.15C324.557 143.191 325.469 141.782 324.523 140.536C323.961 139.796 321.703 139.289 320.801 138.49C317.514 135.581 314.893 129.459 312.622 125.645C310.243 121.651 308.1 117.325 305.111 113.741C300.223 107.881 295.176 101.669 287.26 100.298C283.378 99.6265 279.255 99.9847 275.534 98.644C271.034 97.0224 266.758 94.4677 262.214 92.7882C263.342 90.4706 264.256 86.7851 266.443 86.5322C268.549 86.2878 271.637 88.0979 274.047 88.0848C277.567 88.0652 280.572 87.5026 283.968 86.8317C287.728 86.0881 288.967 86.2234 290.337 82.1451C291.774 77.8727 291.412 72.9108 291.4 68.4733C291.394 66.305 290.964 63.6132 291.149 61.4849C291.426 58.2781 292.05 58.1549 294.563 56.1153C297.704 53.5672 301.576 50.1952 297.728 45.7679C295.65 43.3756 291.377 45.2361 289.536 42.6656C287.661 40.0475 287.751 33.4705 287.18 30.3952C292.961 33.2372 290.842 22.6128 290.843 20.0562C290.844 16.3362 293.337 9.64637 289.748 6.55149C288.08 5.11461 286.841 6.3033 284.934 5.47756C282.759 4.5352 281.388 2.06359 279.073 1.10536C274.473 -0.799901 269.775 1.49443 265.051 1.11562C259.633 0.68176 254.31 -0.156106 248.862 0.713483C246.28 1.12402 245.194 2.10464 243.01 3.20376C240.91 4.26088 238.779 4.55013 236.498 5.23031C234.467 5.83585 232.687 6.14188 231.316 7.91092C230.232 9.31047 230.673 11.6645 229.578 12.8709C228.498 14.0596 226.362 13.887 225.075 15.2987C223.839 16.6535 223.1 18.8927 222.457 20.5787C221.589 22.8498 221.488 23.7025 219.96 25.5201C218.628 27.1063 216.71 28.3817 215.598 30.1909C212.979 34.4558 212.912 40.6231 213.748 45.4208C214.032 47.0546 216.4 51.2775 216.029 52.6677C215.676 53.9908 213.456 53.6427 212.451 54.4797C211.582 55.2028 210.817 58.4245 210.132 58.6214C208.652 59.0459 206.826 56.1227 205.704 55.6842C203.755 54.9219 202.939 54.14 201.859 57.0129C201.059 59.1448 202.174 62.0382 202.761 64.0731C203.508 66.6632 204.333 69.7824 206.312 71.7408C208.638 74.0436 210.5 72.7849 213.067 74.0249C216.913 75.8835 215.778 81.6944 220.511 83.3552C225.021 84.9377 229.991 79.959 233.402 77.6703C232.696 83.2265 230.036 88.5803 231.313 94.2746C220.939 90.2103 210.679 84.4422 199.374 83.1714C193.609 82.523 187.786 81.7551 182.344 84.1483C175.974 86.9493 172.072 93.1279 167.761 98.2614C159.658 107.91 151.344 117.288 143.567 127.247C136.434 136.382 130.42 146.968 122.568 155.522C114.607 164.196 108.599 178.27 109.471 190.282C109.549 191.366 110.389 193.829 110.258 194.999C110.155 195.894 109.341 197.03 109.354 197.752C109.398 200.183 110.202 201.582 112.518 202.93C116.535 205.269 122.52 206.453 127.059 207.034C133.09 207.805 140.475 207.888 146.509 207.065C152.732 206.214 158.202 202.731 163.924 200.626C168.944 198.778 173.985 197.625 179.26 196.447C182.169 195.796 185.39 193.996 187.188 195.738C188.839 197.34 189.182 205.554 189.566 207.738C193.74 231.413 198.699 254.286 203.091 277.84C208.069 304.538 211.473 331.225 214.935 358.15C218.082 382.625 219.11 407.376 219.814 431.828C220.15 443.492 220.199 455.031 220.128 466.705C220.088 473.242 216.82 495.063 226.51 495.898C232.205 496.391 236.761 488.226 238.287 483.773C240.579 477.083 241.773 469.879 242.139 462.852C242.878 448.625 243.848 434.388 244.422 420.155C245.044 404.736 244.253 389.032 242.986 373.663C241.71 358.191 238.495 342.945 237.509 327.45C240.467 331.671 241.414 332.465 246.34 334.303C251.495 336.227 256.455 338.504 261.656 340.298C263.426 340.909 266.188 341.291 267.638 342.29C270.315 344.134 268.557 342.042 269.412 345.631C270.325 349.464 270.497 354.067 270.739 358.006C271.879 376.495 277 394.851 279.363 413.241C279.933 417.682 279.119 436.531 286.761 430.59C292.646 426.015 292.529 411.646 293.367 404.915C294.481 395.943 293.86 386.718 293.684 377.692C293.483 367.411 293.311 356.629 290.858 346.592C295.246 345.841 301.351 347.887 305.769 348.231C309.594 348.529 313.406 348.718 317.209 348.927C326.28 349.425 335.623 349.823 344.847 349.645C346.526 349.612 357.496 348.076 358.898 349.314C359.354 349.716 359.493 355.247 359.578 355.923C359.901 358.465 360.339 361.003 360.665 363.531C361.707 371.61 362.648 380.285 362.349 388.362Z",
  fill: "#113A69"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M199.438 465.143C192.516 467.848 185.168 468.83 178.187 471.294C171.946 473.498 166.15 476.46 160.005 478.699C159.645 475.848 159.454 471.021 160.507 468.334C161.997 464.529 165.92 464.436 169.782 463.081C179.183 459.783 189.071 459.088 198.403 455.235C196.805 458.311 197.519 462.383 199.438 465.143ZM79.9384 455.194C94.8892 455.632 109.178 459.111 123.912 461.263C131.083 462.309 138.259 463.243 145.436 464.22C148.198 464.596 153.232 464.153 155.239 466.544C156.903 468.525 155.079 475.285 155.818 478.188C152.796 478.411 147.431 475.588 144.151 475.12C139.044 474.394 134.004 473.377 128.843 473.053C120.671 472.538 112.64 472.101 104.481 471.191C96.1844 470.266 88.156 468.547 79.793 467.919C75.7275 467.613 74.0922 468.375 73.8527 464.083C73.7586 462.405 73.5285 459.596 73.999 457.942C73.247 455.907 73.9142 454.92 76.0005 454.978C77.3256 454.829 78.6376 454.901 79.9384 455.194ZM108.855 441.496C104.812 441.117 100.752 440.573 96.6988 440.345C95.8769 440.299 91.708 440.55 91.0269 439.785C90.0634 438.705 91.1369 434.751 91.3139 433.527C91.9149 429.367 92.5793 426.948 97.1172 426.939C100.947 426.929 104.912 427.739 108.727 428.113C126.044 429.81 143.274 430.527 160.401 433.75C159.358 438.19 158.175 442.77 159.422 447.31C151.206 447.733 142.186 446.153 134.157 444.531C125.95 442.873 117.242 442.05 108.855 441.496ZM136.264 399.697C142.452 399.725 148.991 402.45 155.096 401.843C155.188 402.979 153.234 402.036 152.694 403.099C151.541 403.102 151.14 403.478 151.492 404.229C151.471 404.741 151.732 405.042 152.278 405.129C152.548 405.153 152.817 405.175 153.085 405.199C154.266 405.237 154.46 406.033 153.665 407.59C154.006 409.518 153.494 411.966 153.42 413.902C142.448 412.409 131.789 410.856 120.739 410.19C115.523 409.875 110.311 409.876 105.101 409.447C99.3684 408.975 93.1113 409.987 87.5074 408.914C84.5117 408.34 84.8257 408.38 85.0437 404.484C85.177 402.117 85.1276 399.307 87.0546 397.581C90.273 394.697 97.6017 396.364 101.45 396.466C113.041 396.772 124.828 397.849 136.264 399.697ZM129.931 455.333C113.356 453.827 96.9057 450.53 80.2365 450.53C81.4153 449.353 83.9824 449.049 85.4491 448.406C87.1217 447.675 88.7002 446.115 90.3346 445.475C93.6145 444.191 96.9523 445.975 100.321 446.746C108.447 448.607 116.785 448.67 124.924 450.496C133.338 452.382 141.863 454.121 150.433 455.081C154.513 455.537 158.891 456.463 162.923 455.385C163.25 455.151 163.579 454.916 163.906 454.683C164.259 453.183 165.237 452.782 166.842 453.481C168.879 453.093 171.475 453.594 173.526 453.645C173.609 454.465 166.03 457.035 164.585 457.671C161.103 459.205 158.741 460.327 155.023 459.67C146.648 458.191 138.411 456.425 129.931 455.333ZM188.238 406.873C187.59 409.398 184.87 408.249 182.529 408.528C179.386 408.9 176.258 409.984 173.214 410.802C167.686 412.287 162.156 413.753 156.65 415.323C156.868 413.099 156.376 408.039 157.551 406.066C158.783 403.998 164.629 403.092 167.35 402.461C174.211 400.873 181.54 401.777 188.51 402.111C188.387 403.696 188.296 405.283 188.238 406.873ZM122.334 422.67C115.824 422.119 109.307 421.69 102.779 421.461C95.3151 421.2 100.74 420.007 100.898 415.455C110.708 417.02 120.604 417.329 130.384 418.666C138.486 419.775 148.137 422.671 156.402 421.116C160.299 420.382 164.279 420.099 168.426 419.685C172.337 419.294 176.028 417.471 179.893 417.019C184.23 416.51 188.662 418.949 192.977 419.593C194.806 419.866 195.231 421.106 196.095 418.905C196.99 416.621 194.425 414.755 193.415 413.39C192.235 411.795 192.725 414.384 192.07 411.894C191.887 411.196 192.384 409.442 192.476 408.69C192.707 406.789 193.304 404.727 193.397 402.829C193.483 401.087 193.498 398.427 191.606 397.41C190.452 396.79 189.634 397.695 188.627 397.519C180.771 396.153 171.53 396.041 163.564 397.36C154.927 398.789 147.493 395.005 138.98 393.471C128.993 391.672 118.902 391.402 108.829 390.642C100.216 389.992 84.48 386.621 81.1991 397.622C80.2701 400.739 78.9162 409.32 81.4162 411.972C84.6962 415.455 92.2914 414.343 96.533 415.248C95.8984 417.053 94.0096 418.28 94.6628 420.43C88.7188 420.711 87.6677 426.325 86.7368 431.567C85.7733 436.989 87.6528 439.145 82.4701 441.969C75.2467 445.904 67.5947 449.879 67.7363 459.252C67.8071 463.965 68.3345 471.072 73.1734 473.517C77.907 475.909 85.6149 475.505 90.8321 476.373C100.935 478.055 111.073 480.029 121.237 481.039C132.06 482.115 143.063 482.998 153.903 483.478C159.81 483.741 164.913 484.634 170.617 482.646C176.226 480.692 181.712 479.265 187.499 477.814C193.212 476.383 210.7 474.455 205.604 464.685C204.789 463.122 202.002 461.879 201.552 460.401C200.826 458.017 203.278 456.156 203.176 454.001C202.988 450.059 198.541 449.564 195.47 449.564C200.733 446.272 193.684 442.374 193.726 439.579C193.8 434.655 199.925 431.458 200.271 427.33C201.114 417.284 169.245 427.744 164.34 429.918C168.115 435.516 185.631 430.672 190.848 429.822C190.136 431.692 189.456 433.372 189.25 435.286C189.083 436.846 189.678 438.628 189.133 440.198C188.272 442.68 188.302 442.205 185.254 442.882C182.999 443.382 180.769 443.961 178.522 444.491C175.069 445.305 169.639 447.491 166.218 447.371C163.218 447.267 163.81 448.197 163.261 444.865C162.964 443.074 163.469 441.17 163.771 439.416C164.401 435.739 165.323 432.259 162.112 429.621C159.05 427.105 152.596 425.908 148.841 425.02C140.506 423.051 130.886 422.569 122.334 422.67Z",
  fill: "#113A69"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M82.6711 359.913C91.7234 358.397 100.921 358.023 110.079 358.483C109.583 360.749 109.087 363.015 108.59 365.28C100.009 363.07 91.3047 361.776 82.6711 359.913ZM156.279 377.495C159.909 377.229 157.383 378.852 156.487 381.228C155.385 384.148 155.621 387.838 155.368 390.911C144.747 386.861 132.388 384.49 121.096 383.127C115.74 382.481 110.307 382.296 104.921 382.02C103.329 381.938 97.5801 382.605 96.4155 381.534C95.5509 380.737 96.1575 376.343 96.9884 375.373C101.509 370.105 118.981 374.654 125.303 375.126C135.667 375.9 145.842 377.752 156.279 377.495ZM141.193 363.375C131.788 364.278 122.707 364.192 113.301 365.601C114.014 359.623 113.162 358.097 119.944 357.78C125.988 357.498 132.013 357.269 138.028 357.272C151.556 357.28 165.051 357.021 178.594 357.021V363.097C166.069 361.814 153.743 364.13 141.193 363.375ZM186.418 385.717C180.483 385.692 174.873 387.931 168.937 388.512C165.384 388.859 166.5 389.3 164.035 391.083C160.197 393.862 159.091 392.382 159.572 388.606C161.203 375.834 177.375 378.698 186.694 377.988C186.082 381.034 187.489 383.617 189.563 385.717H186.418ZM122.262 369.318C130.799 369.457 139.347 369.942 147.824 369.765C151.619 369.685 156.536 368.933 160.255 369.58C162.979 370.054 165.258 371.442 168.246 371.957C163.857 374.322 161.631 372.724 157.017 372.186C152.406 371.649 147.727 371.66 143.098 371.38C135.495 370.919 127.392 369.098 119.901 369.593C119.765 368.538 120.551 368.446 122.262 369.318ZM189.976 396.981C193.893 396.973 188.504 392.518 187.797 392.076C192.134 392.076 193.183 389.475 191.927 385.296C190.743 381.36 189.867 382.565 192.846 379.287C195.088 376.82 195.427 375.001 192.784 372.242C190.094 369.435 184.647 370.229 182.263 367.912C178.206 363.968 183.442 356.113 177.82 353.092C174.02 351.051 167.894 351.304 163.698 350.872C159.642 350.455 155.445 350.375 151.362 350.32C142.463 350.198 133.219 351.69 124.359 352.511C121.129 352.81 117.498 354.115 114.315 354.118C111.07 354.122 107.671 353.398 104.32 353.481C100.424 353.58 96.6716 353.292 92.6544 353.932C89.5765 354.422 82.3897 354.68 80.0372 356.968C72.1981 364.593 90.7878 368.094 93.9863 368.951C90.7308 372.517 90.8663 377.231 91.357 381.721C89.8073 381.721 87.136 381.047 86.3341 382.784C85.3377 384.943 89.025 385.503 89.8971 385.755C94.9125 387.204 100.782 386.807 105.951 387.333C116.285 388.384 126.493 388.991 136.72 390.949C141.703 391.903 146.657 393.083 151.637 394.012C152.497 394.173 153.361 394.301 154.23 394.399C155.563 394.285 155.993 395.121 155.523 396.912C156.906 397.587 162.059 395.904 163.653 395.647C172.776 394.167 180.938 394.782 189.976 396.981Z",
  fill: "#113A69"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.75102 485.573C11.6355 490.203 17.1053 494.573 23.478 498.596C18.9733 498.456 3.99202 491.272 5.75102 485.573ZM8.04942 478.025C11.2609 475.266 14.451 475.548 18.4264 474.712C22.087 473.941 25.6441 472.615 29.2972 471.732C32.164 471.039 35.0019 470.102 37.8584 469.448C41.8925 468.523 42.2904 469.541 46.0003 471.655C59.1565 479.153 73.8788 484.31 87.7365 490.396C83.6679 493.978 74.5151 494.132 69.43 495.274C65.7173 496.107 62.1844 497.247 58.6282 498.566C55.317 499.795 49.9822 502.623 46.4903 502.717C43.5425 502.797 41.1462 499.896 38.6083 498.333C35.2702 496.277 31.9469 494.258 28.5826 492.253C21.4628 488.011 14.8059 482.812 8.04942 478.025ZM67.5061 508.396C69.0247 506.935 73.5964 506.999 75.5008 506.553C79.2517 505.676 82.9477 504.765 86.7489 504.107C92.9175 503.04 102.662 502.562 103.332 494.56C103.89 487.909 95.8542 486.331 91.1539 484.078C84.0862 480.688 76.875 477.56 69.6275 474.571C62.8328 471.77 55.9384 469.401 49.0198 466.979C47.6707 466.507 46.5751 466.572 45.4739 465.492C44.6046 464.64 44.8729 462.985 43.9208 462.095C41.7397 460.056 38.9102 461.128 36.2894 461.651C30.3379 462.838 24.1581 464.397 18.4842 466.599C12.5876 468.887 7.31343 469.365 5.89729 476.05C2.88239 474.635 0.614666 474.43 0.975223 478.587C1.0805 479.808 1.96747 481.136 2.18082 482.396C2.49387 484.253 1.94509 486.21 2.25534 488.072C3.3836 494.841 12.5112 499.856 18.1674 502.514C25.1419 505.791 34.141 510.634 41.9279 511.274C50.2254 511.956 59.2682 508.697 67.5061 508.396Z",
  fill: "#113A69"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M173.125 396.088C175.599 396.103 178.074 396.119 180.547 396.134C178.078 395.67 175.603 395.665 173.125 396.088Z",
  fill: "#113A69"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M317.852 134.336C318.593 135.572 319.335 136.809 320.078 138.047C319.825 136.453 319.259 135.086 317.852 134.336Z",
  fill: "#113A69"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M173.125 431.562C171.638 431.576 170.151 431.588 168.672 431.602C170.162 431.59 171.643 431.577 173.125 431.562Z",
  fill: "#113A69"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M168.672 396.125C170.157 396.111 171.642 396.098 173.125 396.083C171.635 395.677 170.15 395.692 168.672 396.125Z",
  fill: "#113A69"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M109.605 185.547C109.647 184.062 109.688 182.577 109.73 181.094C109.687 182.58 109.647 184.063 109.605 185.547Z",
  fill: "#113A69"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M361.966 409.688C361.996 408.45 362.027 407.212 362.057 405.977C362.026 407.215 361.996 408.451 361.966 409.688Z",
  fill: "#113A69"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M321.562 349.197C320.569 349.198 319.578 349.199 318.594 349.201C319.588 349.201 320.575 349.199 321.562 349.197Z",
  fill: "#113A69"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M188.711 82.6191C189.948 82.7089 191.185 82.798 192.422 82.8878C191.184 82.798 189.948 82.7089 188.711 82.6191Z",
  fill: "#113A69"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M220.199 445.312C220.236 444.321 220.273 443.329 220.309 442.344C220.273 443.336 220.236 444.325 220.199 445.312Z",
  fill: "#113A69"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M218.729 407.461C218.756 406.471 218.783 405.48 218.81 404.492C218.782 405.482 218.755 406.472 218.729 407.461Z",
  fill: "#113A69"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M244.057 424.531C244.022 425.522 243.985 426.513 243.95 427.5C243.986 426.508 244.022 425.521 244.057 424.531Z",
  fill: "#113A69"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M315.625 348.472C314.88 348.461 314.136 348.452 313.398 348.441C314.145 348.452 314.885 348.461 315.625 348.472Z",
  fill: "#113A69"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M100.391 387.098C99.6465 387.067 98.9024 387.034 98.1641 387.002C98.9106 387.035 99.6514 387.067 100.391 387.098Z",
  fill: "#113A69"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M242.583 448.281C242.541 449.272 242.498 450.264 242.456 451.25C242.498 450.256 242.541 449.269 242.583 448.281Z",
  fill: "#113A69"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M163.03 443.086C163.08 444.078 163.13 445.068 163.18 446.055C163.13 445.063 163.08 444.075 163.03 443.086Z",
  fill: "#113A69"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M248.572 0.85076C249.621 0.717166 250.67 0.584685 251.719 0.451091C250.679 0.69156 249.54 -0.200178 248.572 0.85076Z",
  fill: "#113A69"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M293.688 381.484C293.716 382.475 293.744 383.466 293.773 384.453C293.745 383.46 293.717 382.472 293.688 381.484Z",
  fill: "#113A69"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M357.482 472.031C357.532 471.041 357.584 470.051 357.635 469.062C357.584 470.053 357.532 471.042 357.482 472.031Z",
  fill: "#113A69"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M117.461 388.558C116.715 388.542 115.971 388.526 115.234 388.512C115.981 388.528 116.721 388.543 117.461 388.558Z",
  fill: "#113A69"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M369.441 208.555C369.435 209.546 369.43 210.537 369.426 211.523C369.432 210.531 369.436 209.543 369.441 208.555Z",
  fill: "#113A69"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M385.014 431.211C385.016 432.202 385.02 433.194 385.025 434.18C385.022 433.188 385.018 432.199 385.014 431.211Z",
  fill: "#113A69"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M200.035 425.273C200.061 426.264 200.087 427.256 200.116 428.242C200.522 427.224 200.476 426.238 200.035 425.273Z",
  fill: "#113A69"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M219.5 420.82C219.508 419.83 219.515 418.839 219.523 417.852C219.515 418.844 219.508 419.832 219.5 420.82Z",
  fill: "#113A69"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M67.7344 508.738C66.9892 508.758 66.244 508.779 65.5078 508.8C66.256 508.78 66.9952 508.759 67.7344 508.738Z",
  fill: "#113A69"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M94.4531 414.524C93.957 414.515 93.4592 414.507 92.9688 414.498C93.4682 414.507 93.9603 414.515 94.4531 414.524Z",
  fill: "#113A69"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M113.008 416.739C112.51 416.738 112.014 416.737 111.523 416.736C112.021 416.738 112.515 416.739 113.008 416.739Z",
  fill: "#113A69"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M402.045 421.562C402.075 420.82 402.105 420.077 402.134 419.336C402.104 420.079 402.074 420.822 402.045 421.562Z",
  fill: "#113A69"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M98.1641 420.999C98.8087 421.651 99.638 421.266 100.391 421.308C99.6482 421.205 98.9057 421.102 98.1641 420.999Z",
  fill: "#113A69"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M186.484 397.253C187.464 397.716 188.455 397.78 189.453 397.285C188.463 397.274 187.474 397.264 186.484 397.253Z",
  fill: "#113A69"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M121.914 422.688C122.904 422.68 123.894 422.672 124.883 422.663C123.893 422.672 122.903 422.68 121.914 422.688Z",
  fill: "#113A69"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M390.186 393.359C390.204 394.104 390.224 394.847 390.244 395.586C390.226 394.841 390.206 394.1 390.186 393.359Z",
  fill: "#113A69"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M219.569 433.438C219.53 432.694 219.492 431.95 219.455 431.211C219.492 431.956 219.53 432.697 219.569 433.438Z",
  fill: "#113A69"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M117.461 390.637C118.45 390.72 119.44 390.803 120.43 390.886C119.439 390.803 118.45 390.72 117.461 390.637Z",
  fill: "#113A69"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M361.981 388.164C362.001 387.421 362.022 386.677 362.042 385.938C362.022 386.683 362.001 387.424 361.981 388.164Z",
  fill: "#113A69"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M237.979 331.016C238.037 331.759 238.096 332.502 238.154 333.242C238.095 332.499 238.037 331.758 237.979 331.016Z",
  fill: "#113A69"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M102.617 353.474C103.608 353.988 104.598 353.923 105.586 353.469C104.597 353.47 103.606 353.472 102.617 353.474Z",
  fill: "#113A69"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M220.188 456.445C220.232 455.702 220.276 454.959 220.319 454.219C220.276 454.963 220.232 455.704 220.188 456.445Z",
  fill: "#113A69"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M220.207 462.383C220.238 461.64 220.27 460.897 220.301 460.156C220.269 460.9 220.238 461.641 220.207 462.383Z",
  fill: "#113A69"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M360.543 364.414C360.532 363.671 360.522 362.927 360.512 362.188C360.523 362.933 360.533 363.673 360.543 364.414Z",
  fill: "#113A69"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M149.375 482.813C148.878 482.799 148.382 482.785 147.891 482.772C148.39 482.787 148.882 482.8 149.375 482.813Z",
  fill: "#113A69"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M388.67 489.102C388.71 488.358 388.75 487.615 388.791 486.875C388.75 487.618 388.71 488.36 388.67 489.102Z",
  fill: "#113A69"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M228.047 495.395C227.55 495.405 227.052 495.414 226.562 495.425C227.062 495.415 227.554 495.405 228.047 495.395Z",
  fill: "#113A69"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M227.738 431.953C227.695 429.726 227.655 427.499 227.613 425.273C227.655 427.501 227.696 429.727 227.738 431.953Z",
  fill: "#113A69"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M285.605 350.312C285.58 352.045 285.555 353.778 285.528 355.508C285.553 353.773 285.579 352.043 285.605 350.312Z",
  fill: "#113A69"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M413.594 459.02C414.833 459.034 416.073 459.049 417.305 459.066C416.062 459.051 414.828 459.035 413.594 459.02Z",
  fill: "#113A69"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M311.914 311.376C313.154 311.356 314.394 311.336 315.625 311.318C314.382 311.338 313.147 311.357 311.914 311.376Z",
  fill: "#113A69"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M343.828 340.295C342.59 340.294 341.353 340.293 340.117 340.291C341.354 340.292 342.591 340.293 343.828 340.295Z",
  fill: "#113A69"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M327.5 310.581C328.493 310.597 329.485 310.614 330.469 310.63C329.473 310.614 328.486 310.597 327.5 310.581Z",
  fill: "#113A69"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M407.656 459.051C408.648 459.046 409.641 459.04 410.625 459.035C409.629 459.041 408.643 459.046 407.656 459.051Z",
  fill: "#113A69"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M274.062 79.9138C272.826 79.8277 271.588 79.7423 270.352 79.6562C271.589 79.7423 272.826 79.8277 274.062 79.9138Z",
  fill: "#113A69"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M257.432 166.992C257.386 165.755 257.34 164.518 257.294 163.281C257.341 164.52 257.386 165.756 257.432 166.992Z",
  fill: "#113A69"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M287.422 178.495C288.167 178.495 288.911 178.496 289.648 178.497C288.901 178.497 288.162 178.496 287.422 178.495Z",
  fill: "#113A69"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M350.508 308.366C351.253 308.374 351.997 308.383 352.734 308.391C351.987 308.383 351.247 308.375 350.508 308.366Z",
  fill: "#113A69"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M367.578 338.688C366.588 338.768 365.598 338.849 364.609 338.929C365.599 338.849 366.588 338.768 367.578 338.688Z",
  fill: "#113A69"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M369.457 376.289C369.441 375.298 369.425 374.309 369.41 373.32C369.426 374.312 369.441 375.301 369.457 376.289Z",
  fill: "#113A69"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M284.453 336.727C283.464 336.63 282.473 336.534 281.484 336.437C282.474 336.534 283.464 336.63 284.453 336.727Z",
  fill: "#113A69"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M216.631 319.141C216.572 318.15 216.513 317.159 216.455 316.172C216.513 317.163 216.573 318.152 216.631 319.141Z",
  fill: "#113A69"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M304.492 312.101C305.236 312.093 305.982 312.086 306.719 312.079C305.971 312.086 305.231 312.093 304.492 312.101Z",
  fill: "#113A69"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M369.379 431.953C369.416 431.21 369.453 430.467 369.488 429.727C369.453 430.47 369.416 431.212 369.379 431.953Z",
  fill: "#113A69"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M286.166 394.102C284.544 398.124 285.455 395.276 285.413 396.204C286.795 396.39 287.047 395.689 286.166 394.102Z",
  fill: "#113A69"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M354.219 308.419C354.963 308.392 355.709 308.365 356.445 308.338C355.696 308.365 354.959 308.391 354.219 308.419Z",
  fill: "#113A69"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M202.511 233.047C202.464 232.057 202.417 231.067 202.371 230.078C202.418 231.069 202.465 232.058 202.511 233.047Z",
  fill: "#113A69"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M369.43 424.531C369.432 423.541 369.435 422.552 369.437 421.562C369.435 422.555 369.433 423.543 369.43 424.531Z",
  fill: "#113A69"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M369.511 402.266C369.46 401.523 369.407 400.78 369.356 400.039C369.408 400.783 369.46 401.525 369.511 402.266Z",
  fill: "#113A69"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M215.162 305.039C215.093 304.296 215.023 303.553 214.954 302.812C215.023 303.556 215.093 304.298 215.162 305.039Z",
  fill: "#113A69"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M379.181 404.492C379.115 405.236 379.048 405.98 378.982 406.719C379.049 405.976 379.115 405.234 379.181 404.492Z",
  fill: "#113A69"
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M380.676 398.555C380.603 399.297 380.53 400.041 380.457 400.781C380.53 400.037 380.603 399.296 380.676 398.555Z",
  fill: "#113A69"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M232.212 296.875C232.156 296.133 232.101 295.39 232.046 294.648C232.102 295.392 232.157 296.133 232.212 296.875Z",
  fill: "#113A69"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M611.016 397.558C610.027 397.48 609.037 397.401 608.047 397.324C609.039 397.402 610.028 397.48 611.016 397.558Z",
  fill: "#113A69"
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M238.766 415.625C238.795 416.369 238.824 417.114 238.851 417.852C238.822 417.106 238.794 416.366 238.766 415.625Z",
  fill: "#113A69"
});

var _ref76 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M227.016 417.852C226.961 417.109 226.906 416.366 226.851 415.625C226.906 416.368 226.961 417.11 227.016 417.852Z",
  fill: "#113A69"
});

var _ref77 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M231.504 293.906C231.426 293.163 231.347 292.421 231.269 291.68C231.347 292.424 231.426 293.165 231.504 293.906Z",
  fill: "#113A69"
});

var _ref78 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M605.078 396.844C604.088 396.747 603.098 396.65 602.109 396.553C603.098 396.65 604.089 396.747 605.078 396.844Z",
  fill: "#113A69"
});

var _ref79 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M290.391 311.339C290.887 311.344 291.385 311.35 291.875 311.355C291.376 311.35 290.883 311.344 290.391 311.339Z",
  fill: "#113A69"
});

var _ref80 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M369.43 395.586C369.432 394.842 369.435 394.099 369.437 393.359C369.435 394.104 369.432 394.844 369.43 395.586Z",
  fill: "#113A69"
});

var _ref81 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M225.391 394.102C225.654 393.334 225.784 392.578 225.275 391.875C225.314 392.618 225.352 393.36 225.391 394.102Z",
  fill: "#113A69"
});

var _ref82 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M238.035 380C238.055 380.743 238.078 381.487 238.098 382.227C238.076 381.482 238.055 380.741 238.035 380Z",
  fill: "#113A69"
});

var _ref83 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M237.394 453.477C237.348 454.219 237.301 454.963 237.255 455.703C237.301 454.96 237.348 454.217 237.394 453.477Z",
  fill: "#113A69"
});

var _ref84 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M182.773 183.532C182.03 183.638 181.288 183.744 180.547 183.849C181.29 183.743 182.031 183.638 182.773 183.532Z",
  fill: "#113A69"
});

var _ref85 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M185.742 183.602C184.746 183.662 183.652 183.184 182.773 183.885L185.742 183.602Z",
  fill: "#113A69"
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M312.656 340.3C311.667 340.296 310.676 340.29 309.688 340.285C310.677 340.29 311.667 340.296 312.656 340.3Z",
  fill: "#113A69"
});

var _ref87 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M290.391 182.82L287.422 183.078C288.413 182.992 289.401 182.906 290.391 182.82Z",
  fill: "#113A69"
});

var _ref88 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M339.375 340.099C338.384 340.103 337.396 340.108 336.406 340.112C337.4 340.59 338.389 340.637 339.375 340.099Z",
  fill: "#113A69"
});

var _ref89 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M366.38 464.609C366.436 463.865 366.493 463.122 366.55 462.383C366.493 463.127 366.436 463.868 366.38 464.609Z",
  fill: "#113A69"
});

var _ref90 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M258.122 184.062C258.11 183.319 258.1 182.577 258.089 181.836C258.1 182.58 258.11 183.322 258.122 184.062Z",
  fill: "#113A69"
});

var _ref91 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M320.82 340.413C319.83 340.333 318.841 340.253 317.852 340.173C318.842 340.253 319.83 340.333 320.82 340.413Z",
  fill: "#113A69"
});

var _ref92 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M236.607 471.289C236.591 472.032 236.574 472.775 236.557 473.516C236.574 472.771 236.591 472.03 236.607 471.289Z",
  fill: "#113A69"
});

var _ref93 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M221.098 354.766C221.029 354.023 220.961 353.28 220.894 352.539C220.962 353.283 221.03 354.024 221.098 354.766Z",
  fill: "#113A69"
});

var _ref94 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M186.94 156.602C186.883 155.858 186.827 155.116 186.77 154.375C186.827 155.118 186.884 155.86 186.94 156.602Z",
  fill: "#113A69"
});

var _ref95 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M257.385 92.7734C257.371 93.5162 257.357 94.2599 257.342 95C257.356 94.2554 257.37 93.5144 257.385 92.7734Z",
  fill: "#113A69"
});

var _ref96 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M283.711 78.9189C282.721 79.0013 281.731 79.0845 280.742 79.1661C281.732 79.0837 282.721 79.0013 283.711 78.9189Z",
  fill: "#113A69"
});

var _ref97 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M432.148 500.751C431.159 500.654 430.17 500.557 429.18 500.46C430.17 500.557 431.159 500.654 432.148 500.751Z",
  fill: "#113A69"
});

var _ref98 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M282.227 71.6216C282.723 71.6209 283.221 71.6201 283.711 71.6201C283.212 71.6216 282.719 71.6216 282.227 71.6216Z",
  fill: "#113A69"
});

var _ref99 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M464.805 510.417C463.814 509.907 462.826 510.052 461.836 510.421C462.826 510.419 463.816 510.419 464.805 510.417Z",
  fill: "#113A69"
});

var _ref100 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M79.6094 454.556C80.6021 454.578 81.5939 454.601 82.5781 454.624C81.5835 454.602 80.5965 454.578 79.6094 454.556Z",
  fill: "#113A69"
});

var _ref101 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M94.4531 439.836C93.2161 439.741 91.9792 439.647 90.7422 439.553C91.896 440.278 93.2161 439.741 94.4531 439.836Z",
  fill: "#113A69"
});

var _ref102 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M108.555 441.364C107.317 441.275 106.081 441.186 104.844 441.096C106.08 441.186 107.317 441.275 108.555 441.364Z",
  fill: "#113A69"
});

var _ref103 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M124.141 454.707C123.151 454.629 122.161 454.55 121.172 454.472C122.161 454.55 123.151 454.628 124.141 454.707Z",
  fill: "#113A69"
});

var _ref104 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M120.43 453.979C119.44 453.891 118.451 453.804 117.461 453.716C118.45 453.803 119.44 453.891 120.43 453.979Z",
  fill: "#113A69"
});

var _ref105 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M115.234 428.606C115.979 428.612 116.723 428.617 117.461 428.62C116.713 428.614 115.974 428.61 115.234 428.606Z",
  fill: "#113A69"
});

var _ref106 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M96.6797 469.494C95.6901 469.411 94.7005 469.326 93.7109 469.243C94.6344 469.892 95.6779 469.519 96.6797 469.494Z",
  fill: "#113A69"
});

var _ref107 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M128.594 398.184C129.339 398.183 130.083 398.182 130.82 398.182C130.072 398.182 129.333 398.183 128.594 398.184Z",
  fill: "#113A69"
});

var _ref108 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M136.016 399.664C136.512 399.667 137.009 399.669 137.5 399.671C137.001 399.668 136.508 399.666 136.016 399.664Z",
  fill: "#113A69"
});

var _ref109 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M153.828 401.732C154.078 402.342 155.389 402.264 155.309 401.638C154.816 401.669 154.323 401.701 153.828 401.732Z",
  fill: "#113A69"
});

var _ref110 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M188.385 404.492C188.354 405.234 188.324 405.978 188.294 406.719C188.325 405.975 188.354 405.233 188.385 404.492Z",
  fill: "#113A69"
});

var _ref111 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M87.0312 408.426C86.2893 408.413 85.5466 408.401 84.8047 408.389C85.5377 408.913 86.2813 408.839 87.0312 408.426Z",
  fill: "#113A69"
});

var _ref112 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M115.234 397.431C115.731 397.438 116.228 397.446 116.719 397.451C116.219 397.445 115.727 397.438 115.234 397.431Z",
  fill: "#113A69"
});

var _ref113 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M134.531 444.337C133.541 444.245 132.551 444.153 131.562 444.061C132.552 444.153 133.541 444.245 134.531 444.337Z",
  fill: "#113A69"
});

var _ref114 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M124.141 472.557C123.149 472.195 122.158 472.071 121.172 472.566C122.162 472.563 123.151 472.56 124.141 472.557Z",
  fill: "#113A69"
});

var _ref115 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M125.714 370.253L127.109 369.771C125.378 369.749 123.646 369.728 121.914 369.707C121.91 369.708 125.515 370.269 125.714 370.253Z",
  fill: "#113A69"
});

var _ref116 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M138.984 357.364C140.224 357.363 141.464 357.362 142.695 357.361C141.453 357.363 140.219 357.364 138.984 357.364Z",
  fill: "#113A69"
});

var _ref117 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M185.742 385.734C184.508 385.24 183.27 385.337 182.031 385.721C183.269 385.725 184.505 385.73 185.742 385.734Z",
  fill: "#113A69"
});

var _ref118 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M110.781 373.678C111.526 373.687 112.271 373.696 113.008 373.704C112.261 373.695 111.521 373.687 110.781 373.678Z",
  fill: "#113A69"
});

var _ref119 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M126.367 363.921C125.13 364.002 123.892 364.083 122.656 364.164C123.893 364.082 125.131 364.002 126.367 363.921Z",
  fill: "#113A69"
});

var _ref120 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M140.469 363.179C139.479 363.26 138.489 363.341 137.5 363.422C138.49 363.341 139.479 363.26 140.469 363.179Z",
  fill: "#113A69"
});

var _ref121 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M154.57 377.418C155.067 377.407 155.564 377.397 156.055 377.387C155.556 377.397 155.063 377.407 154.57 377.418Z",
  fill: "#113A69"
});

var _ref122 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M138.984 370.026C139.482 369.995 139.978 369.965 140.469 369.934C139.97 369.964 139.477 369.995 138.984 370.026Z",
  fill: "#113A69"
});

var _ref123 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M148.633 370.001C149.13 369.987 149.627 369.973 150.117 369.96C149.618 369.974 149.126 369.987 148.633 370.001Z",
  fill: "#113A69"
});

var _ref124 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M121.914 369.311C121.914 369.503 119.679 368.528 119.688 369.435L121.914 369.311Z",
  fill: "#113A69"
});

var _ref125 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M130.078 357.361C130.575 357.362 131.072 357.363 131.562 357.364C131.063 357.363 130.571 357.362 130.078 357.361Z",
  fill: "#113A69"
});

var _ref126 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M393.555 322.166C392.751 318.886 392.97 316.32 390.108 318.416C388.537 319.566 385.947 325.402 386.143 327.378C386.386 329.816 387.497 330.788 389.792 330.012C392.43 329.118 393.476 324.619 393.555 322.166Z",
  fill: "#113A69"
});

var _ref127 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M248.954 302.254C242.308 302.254 245.208 309.327 250.748 309.486C253.294 309.559 256.957 309.056 256.131 305.648C255.69 303.83 249.232 301.377 248.954 302.254Z",
  fill: "#113A69"
});

var _ref128 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M320.246 316.172C315.448 318.493 322.198 328.688 326.558 326.164C332.141 322.934 322.219 317.626 320.246 316.172Z",
  fill: "#113A69"
});

var _ref129 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M331.921 325.82C330.35 327.533 323.273 333.341 327.174 335.676C331.971 338.548 335.622 329.068 331.921 325.82Z",
  fill: "#113A69"
});

var _ref130 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M412.348 321.367C413.909 318.349 411.761 310.45 406.995 311.893C402.199 313.347 409.709 320.566 412.348 321.367Z",
  fill: "#113A69"
});

var _ref131 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M306.466 323.107C303.355 321.854 303.947 325.561 303.477 326.756C302.944 328.115 300.204 331.423 300.891 332.869C301.911 335.014 304.349 333.646 305.673 332.254C307.994 329.812 307.829 325.895 306.466 323.107Z",
  fill: "#113A69"
});

var _ref132 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M353.892 326.542C356.486 326.542 362.677 319.064 359.039 317.809C354.524 316.252 350.748 327.092 353.892 326.542Z",
  fill: "#113A69"
});

var _ref133 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M264.259 314.688C261.884 315.273 258.74 321.999 262.32 322.779C266.284 323.643 266.991 316.547 264.259 314.688Z",
  fill: "#113A69"
});

var _ref134 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M278.662 327.305C280.525 323.717 280.984 316.037 276.435 322.201C275.45 323.537 274.433 322.997 274.939 325.199C275.381 327.122 277.147 327.305 278.662 327.305Z",
  fill: "#113A69"
});

var _ref135 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M376.792 308.75C374.894 311.608 375.454 320.57 379.422 315.27C381.109 313.016 379.947 308.857 376.792 308.75Z",
  fill: "#113A69"
});

var _ref136 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M281.345 39.4086C277.661 38.4575 276.777 47.1432 278.926 48.1007C281.934 49.4406 281.557 40.8615 281.345 39.4086Z",
  fill: "#113A69"
});

var _ref137 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M48.3217 480.677C51.7409 480.477 56.5308 479.545 51.3514 477.118C48.0655 475.581 43.1795 475.473 39.7097 476.104C37.3182 476.539 33.7294 478.522 37.3791 481.092C39.5154 482.595 45.7244 480.751 48.3217 480.677Z",
  fill: "#113A69"
});

var _ref138 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M52.1539 486.875C53.1427 486.763 54.1305 486.652 55.1172 486.541C54.3243 485.103 52.0213 484.8 52.1539 486.875Z",
  fill: "#113A69"
});

var _ref139 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M47.6953 480.534C46.7032 480.556 45.711 480.578 44.7266 480.599C45.7216 480.577 46.7089 480.556 47.6953 480.534Z",
  fill: "#113A69"
});

function SvgSitReadingDoodle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 660,
    height: 523,
    viewBox: "0 0 660 523",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132, _ref133, _ref134, _ref135, _ref136, _ref137, _ref138, _ref139);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSitReadingDoodle);
export default __webpack_public_path__ + "static/media/sit-reading-doodle.8e090a8d61501977b6cfa6f12cbd410f.svg";
export { ForwardRef as ReactComponent };